const OBJECT_ID_PATTERN = /^[0-9a-fA-F]{24}$/

function stripOtpDigits(value: string): string {
  return value.split('').filter((c) => c >= '0' && c <= '9').join('')
}

/** OTP digits from legacy email links that included `?code=` (identity now sends session-only). */
export function parseSignupVerifyOtpFromSearch(search: string): string {
  const params = new URLSearchParams(search)
  return stripOtpDigits(params.get('code') ?? '').slice(0, 6)
}

export function normalizeSignupVerifySessionId(search: string): string {
  return (new URLSearchParams(search).get('session') ?? '').trim()
}

export function isValidSignupVerifySessionId(sessionId: string): boolean {
  return OBJECT_ID_PATTERN.test(sessionId)
}

/** True when the query string should be replaced with `{ session }` only. */
export function signupVerifyUrlNeedsCleaning(search: string): boolean {
  const params = new URLSearchParams(search)
  if (params.size === 0) return false
  return [...params.keys()].some((key) => key !== 'session')
}

export function signupVerifyCleanSearch(sessionId: string): string {
  return `session=${encodeURIComponent(sessionId)}`
}
